import React from 'react';
import VButton from '../VButton.jsx';

const PollForm = props => (
  <div className="poll-form">
    <form onSubmit={evt => props.handleSubmit(evt, props.vote)}>
      {props.choices.map(({ label, id }) => {
        return (
          <label className="choice" key={id}>
            {label}
            <input type="radio"
              name="radio"
              value={id}
              onChange={props.handleChoice}
            />
            <div className="choice-indicator"></div>
          </label>
        );
      })}

      <div className="vote">
        <VButton type="primary" elementType="button">{props.t('Poll.button')}</VButton>
      </div>
    </form>
  </div>
);

PollForm.propTypes = {
  t: React.PropTypes.func.isRequired,
  vote: React.PropTypes.shape({
    pollId: React.PropTypes.string,
    choiceId: React.PropTypes.string,
    country: React.PropTypes.string,
  }),
  handleChoice: React.PropTypes.func.isRequired,
  handleSubmit: React.PropTypes.func.isRequired,
  choices: React.PropTypes.array.isRequired,
};

export default PollForm;



// WEBPACK FOOTER //
// ./src/component/ArticleFeed/PollForm.jsx